
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Urbaniahireforcorporateeventainpune() {



  const cardData =
  {
    keyword: ' Urbania Hire for Corporate Event in Pune',
    heading: 'Vaishnavi Travels: Urbania Hire for Corporate Event in Pune',
    headingDescription: 'Vaishnavi Travels offers premium and reliable Urbania Hire for Corporate Event in Pune, ensuring smooth and professional transportation for employees, delegates, and business guests. Our Urbania vehicles are equipped with spacious push-back seating, modern interiors, powerful air-conditioning, and ample luggage capacity, providing a comfortable and luxurious travel experience. With professional chauffeurs, timely pickups, and flexible booking options, we make corporate event travel stress-free and efficient. Whether it’s a conference, seminar, team outing, or client meeting, Vaishnavi Travels guarantees safe, stylish, and dependable Urbania rental services in Pune for all your corporate events.',

    top: 'Top Places to Visit in Pune with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort palace and a proud symbol of Maratha power. Once the seat of the Maratha Empire, its massive gates, sprawling gardens, and ruins narrate tales of valor. Though partially destroyed by a fire in 1828, it still draws thousands of visitors every day. The evening light-and-sound show brings alive the love story of Bajirao and Mastani and the grandeur of the Peshwas. Its corridors, courtyards, and fountains carry echoes of Maratha history. Shaniwar Wada remains Pune’s most cherished cultural landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Built in 1892, the Aga Khan Palace is one of Pune’s most historic monuments linked to India’s freedom struggle. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. Today, the palace houses a museum displaying Gandhi’s personal belongings, letters, and photographs. Its Italian arches and sprawling gardens add architectural charm and peaceful vibes. Tourists enjoy strolling through its lawns while reflecting on history. Aga Khan Palace is Pune’s inspirational symbol of patriotism and sacrifice."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is a legendary hill fort known for the 1670 battle where Tanaji Malusare fought valiantly for Chhatrapati Shivaji Maharaj. Perched atop a hill, it offers breathtaking panoramic views of the Sahyadris and trekking trails loved by adventurers. The fort still houses bastions, memorials, and temples that narrate Maratha bravery. During monsoon, mist and waterfalls enhance its charm. Visitors also relish rustic delicacies like pithla-bhakri at local stalls. Sinhagad Fort is Pune’s perfect blend of history, nature, and adventure."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. Established over 125 years ago, it houses a magnificent idol adorned with gold and ornaments. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities attracting lakhs of devotees. Known for its charitable and cultural initiatives, it serves as both a spiritual and social hub. The temple’s vibrant aura captivates tourists and locals alike. Dagdusheth Ganpati Temple is Pune’s divine and cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "The Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. It features massive stone pillars, sanctum chambers, and a Nandi mandapa. Despite being in the city center, it offers peace and meditation amidst the chaos. Evening prayers and chants add to its mystical ambiance. The temple reflects ancient Indian craftsmanship and architectural skill. Pataleshwar Cave Temple is Pune’s hidden gem of spiritual heritage."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum is a cultural treasure housing over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include musical instruments, ornaments, sculptures, and everyday antiques. A highlight is the recreated Mastani Mahal, reflecting the romance of Maratha history. Students and history enthusiasts find it deeply educational and fascinating. The museum preserves centuries of traditions and artistry under one roof. Raja Dinkar Kelkar Museum is Pune’s proud showcase of culture and heritage."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest heritage landmarks, offers panoramic views of the city from its temple complex. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller temples and a museum add depth to the visit. Pilgrims and tourists climb 103 steps to reach the top, combining devotion with scenic beauty. Sunrise and sunset views from here are mesmerizing. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global hub for wellness, spirituality, and mindfulness. Spread across lush gardens, it attracts seekers and tourists from all over the world. The ashram offers meditation sessions, yoga practices, and personal growth workshops. Its Japanese Zen gardens and tranquil halls enhance the experience. Beyond spirituality, it is also a retreat for relaxation and rejuvenation. Osho Ashram is Pune’s international center of peace and healing."
  },
  {
    "title": "Pu La Deshpande Garden (Okayama Friendship Garden)",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. With flowing streams, stone bridges, and manicured lawns, it is a paradise for nature lovers. Families enjoy picnics, photography, and peaceful walks here. The garden symbolizes Indo-Japanese friendship and cultural exchange. Seasonal flowers add color and charm throughout the year. Pu La Deshpande Garden is Pune’s green paradise of calm and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is Pune’s popular weekend getaway. It supplies water to the city while offering scenic backdrops of hills and flowing waters. During monsoon, the overflowing dam creates spectacular views. Families enjoy roadside snacks like roasted corn and tea by the banks. It also serves as the gateway to Sinhagad Fort nearby. Khadakwasla Dam is Pune’s refreshing natural retreat for relaxation and leisure."
  }
],


  "services": [
    {
      "name": "Corporate Urbania Rental Pune",
      "description": "Avail premium Corporate Urbania rental services in Pune tailored for smooth and efficient office travel. Our Urbania vans provide comfortable seating and modern amenities ideal for daily commutes, inter-office transfers, and business meetings. Experience punctuality and professionalism with well-maintained vehicles and courteous drivers, ensuring your corporate transport needs are met seamlessly."
    },
    {
      "name": "Urbania for Office Travel Pune",
      "description": "Make office travel hassle-free with our Urbania vans in Pune, designed to cater specifically to corporate staff. These vans offer reliable pick-up and drop services, spacious interiors, and air conditioning, providing a stress-free commute. Perfect for employee shuttles, project site visits, and client transport within the city and nearby areas."
    },
    {
      "name": "Business Event Urbania Hire",
      "description": "Book Urbania vans for business events, seminars, and exhibitions across Pune. Our vans ensure timely arrivals, comfort, and professional drivers, making transportation logistics effortless for organizers and attendees alike. Choose from AC and Non-AC options with customizable packages for short or long durations."
    },
    {
      "name": "AC Urbania Van Corporate Use",
      "description": "Travel in cool comfort with our air-conditioned Urbania vans tailored for corporate use. Equipped with ergonomic seating, ample legroom, and advanced climate control, these vans are perfect for client meetings, airport transfers, and executive travel. Enjoy a smooth ride with minimal cabin noise and modern interiors."
    },
    {
      "name": "Corporate Staff Travel Urbania",
      "description": "Ensure safe and comfortable travel for your corporate staff with our dedicated Urbania van services. Ideal for regular office commutes, inter-branch transfers, and team outings, these vans come with trained drivers and flexible timings to suit your business needs."
    },
    {
      "name": "Urbania for Seminars & Exhibitions",
      "description": "Facilitate seamless transport for participants and organizers during seminars and exhibitions in Pune with our Urbania vans. Designed to accommodate small to mid-sized groups, these vehicles provide efficient mobility, ensuring punctuality and convenience."
    },
    {
      "name": "13/17 Seater Urbania for Corporates",
      "description": "Choose between 13 and 17 seater Urbania vans for your corporate travel needs in Pune. These vans combine spacious interiors with comfort features like AC, cushioned seats, and ample storage space, ideal for business trips, client visits, and group travel."
    },
    {
      "name": "Urbania for Business Outings Pune",
      "description": "Plan your corporate outings and team-building activities with our reliable Urbania van rentals in Pune. Offering spacious seating and premium amenities, our vans ensure a pleasant travel experience for your workforce on offsite events and retreats."
    },
    {
      "name": "Executive Urbania Hire Pune",
      "description": "Hire our Executive Urbania vans in Pune for high-profile business travel. Featuring luxury interiors, leather seating, and advanced entertainment systems, these vans provide a sophisticated and comfortable environment for VIP clients and executives."
    },
    {
      "name": "Corporate Shuttle Van Urbania Pune",
      "description": "Optimize employee commute with our Corporate Shuttle Urbania vans in Pune. Providing fixed-route shuttle services with punctual pick-ups and drop-offs, these vans are an economical and efficient solution for daily office travel."
    },
    {
      "name": "Urbania Transport for Conferences",
      "description": "Facilitate smooth transport during conferences with our Urbania van rentals in Pune. Ideal for shuttling speakers, delegates, and guests between venues, hotels, and airports, our vans ensure timely and comfortable transit."
    },
    {
      "name": "Urbania for VIP Travel Pune",
      "description": "Experience premium VIP travel in Pune with our luxury Urbania vans, perfect for corporate leaders and distinguished guests. Enjoy exclusive amenities, privacy, and top-notch service with professionally trained drivers."
    },
    {
      "name": "Urbania with Driver Corporate Events",
      "description": "Hire Urbania vans with professional drivers included for your corporate events in Pune. Drivers are well-versed with local routes and business etiquette, ensuring reliable and courteous service throughout your event."
    }
  ],
  "tableData": [
    ["Corporate Urbania Rental Pune", "Urbania for Office Travel Pune"],
    ["Business Event Urbania Hire", "AC Urbania Van Corporate Use"],
    ["Corporate Staff Travel Urbania", "Urbania for Seminars & Exhibitions"],
    ["13/17 Seater Urbania for Corporates", "Urbania for Business Outings Pune"],
    ["Executive Urbania Hire Pune", "Corporate Shuttle Van Urbania Pune"],
    ["Urbania Transport for Conferences", "Urbania for VIP Travel Pune"],
    ["Urbania with Driver Corporate Events"]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Urbania Hire for Corporate Event in Pune",
    "WhyChoosedescription": "Vaishnavi Travels offers premium Force Urbania vans on hire for corporate events in Pune — perfect for executive transport, team movement, and VIP guest travel."
  },
  {
    "WhyChooseheading": "Luxury Travel for Business Needs",
    "WhyChoosedescription": "Our Urbania vehicles feature reclining leather seats, individual AC vents, USB charging, and smooth suspension for a first-class corporate travel experience."
  },
  {
    "WhyChooseheading": "Punctual and Professional Service",
    "WhyChoosedescription": "We understand the importance of time in business. Our trained chauffeurs ensure timely pickups and drop-offs for your corporate schedule."
  },
  {
    "WhyChooseheading": "Spotless and Well-Maintained Vehicles",
    "WhyChoosedescription": "Each Urbania van is sanitized, cleaned, and checked for performance before every corporate booking."
  },
  {
    "WhyChooseheading": "Custom Packages for Corporate Clients",
    "WhyChoosedescription": "Whether you need the vehicle for a few hours, a full-day event, or multi-day conferences, we offer flexible rental plans to suit your business needs."
  },
  {
    "WhyChooseheading": "All-Inclusive Transparent Pricing",
    "WhyChoosedescription": "Our corporate pricing includes fuel, tolls, taxes, and driver allowance — no hidden fees or last-minute surprises."
  },
  {
    "WhyChooseheading": "Perfect for Meetings, Conferences & Airport Transfers",
    "WhyChoosedescription": "Hire Urbania vans for seamless transportation during business conferences, off-sites, client visits, or executive airport transfers in Pune."
  },
  {
    "WhyChooseheading": "Dedicated Support for Corporate Accounts",
    "WhyChoosedescription": "Our 24/7 customer service team ensures smooth coordination, itinerary updates, and round-the-clock assistance for all business travel needs."
  }
]




















  }






const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels offer 13 seater Force Urbania on rent for corporate events in Pune?',
      answer: 'Yes, Vaishnavi Travels provides 13 seater Force Urbania vehicles on rent in Pune, ideal for corporate events, business meetings, and office transfers within the city and nearby locations.',
    },
    {
      question: 'What features make the 13 seater Force Urbania suitable for corporate event transportation in Pune?',
      answer: 'The 13 seater Force Urbania offers spacious, comfortable seating, air-conditioning, ample legroom, modern interiors, and reliable performance to ensure a smooth and professional travel experience.',
    },
    {
      question: 'Are the vehicles and drivers reliable for corporate event transportation in Pune?',
      answer: 'Absolutely! All vehicles are well-maintained and serviced regularly. Our professional drivers are punctual, courteous, and knowledgeable about Pune routes to ensure timely arrivals and departures.',
    },
    {
      question: 'What is the rental cost for hiring a 13 seater Force Urbania for corporate events in Pune?',
      answer: 'Rental costs typically start from ₹4,000 for half-day corporate event hire in Pune. Pricing varies based on duration, distance, and any additional requirements.',
    },
    {
      question: 'Can I book the 13 seater Force Urbania for corporate event transfers outside Pune?',
      answer: 'Yes, we offer outstation and intercity packages for corporate events outside Pune with transparent pricing and professional service.',
    },
    {
      question: 'How early should I book the 13 seater Urbania for a corporate event in Pune?',
      answer: 'We recommend booking at least 3-4 days in advance, especially for weekends or large corporate events, to ensure vehicle availability.',
    },
    {
      question: 'Is flexible pickup and drop-off available for corporate event transportation in Pune?',
      answer: 'Yes, Vaishnavi Travels provides flexible pickup and drop locations across Pune and surrounding areas to fit your event schedule.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Amit Kulkarni",
    position: "Corporate Manager",
    feedback:
      "Vaishnavi Travels provided excellent service for our corporate event in Pune. The 13 seater Urbania was spacious, clean, and comfortable. The driver was punctual and professional throughout the day.",
    rating: 5,
  },
  {
    name: "Ms. Neha Patil",
    position: "Event Organizer",
    feedback:
      "We hired a 13 seater Urbania from Vaishnavi Travels for a corporate seminar in Pune. The vehicle was perfect for our team transfer, and the support staff was very cooperative. Highly recommended!",
    rating: 5,
    style: "style-2",
  }
];
































































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania Hire for Corporate Event in Pune",
  "image": "https://vaishnavitravel.com/assets/images/urbania-corporate-event-rental-pune.jpg",
  "description": "Hire AC Force Urbania (13 or 17 seater) for corporate events in Pune with Vaishnavi Travels. Perfect for office travel, business conferences, VIP guest transport, exhibitions, and executive outings.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.88",
    "ratingCount": "412"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4300",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/urbania-hire-for-corporate-event-in-pune"
  }
};




  return (
    <div>

<Helmet>
  <title>Urbania Hire for Corporate Event in Pune | Executive Travel | Vaishnavi Travels</title>
  <meta
    name="description"
    content="Hire AC Force Urbania (13 or 17 seater) for corporate events in Pune with Vaishnavi Travels. Perfect for office travel, business conferences, VIP guest transport, exhibitions, and executive outings."
  />
  <meta
    name="keywords"
    content="Corporate Urbania Rental Pune, Urbania for Office Travel Pune, Business Event Urbania Hire, AC Urbania Van Corporate Use, Corporate Staff Travel Urbania, Urbania for Seminars & Exhibitions, 13/17 Seater Urbania for Corporates, Urbania for Business Outings Pune, Executive Urbania Hire Pune, Corporate Shuttle Van Urbania Pune, Urbania Transport for Conferences, Urbania for VIP Travel Pune, Urbania with Driver Corporate Events"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/39.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Urbaniahireforcorporateeventainpune;